import script from "./tipsComponets.vue?vue&type=script&setup=true&lang=js"
export * from "./tipsComponets.vue?vue&type=script&setup=true&lang=js"

import "./tipsComponets.vue?vue&type=style&index=0&id=edb2c5e0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edb2c5e0"]])

export default __exports__